export const generateCacheKey = (queryKey: string | string[]) => {
  return JSON.stringify(queryKey);
};
